var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cog-picker",
      class: { "cog-picker__native-icon-container": _vm.$slots.icon }
    },
    [
      _vm.placeholder && _vm.showPlaceholder
        ? _c("input", {
            staticClass: "cog-picker__native-placeholder el-input__inner",
            attrs: {
              inert: "",
              "aria-hidden": "true",
              tabindex: "-1",
              type: "text",
              placeholder: _vm.placeholder
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.$slots.icon
        ? _c("span", { staticClass: "el-input__suffix" }, [_vm._t("icon")], 2)
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }